import type { WebsiteSeoDocument } from './seo';

/** Error pages and incomplete fetches cannot establish a metadata baseline. */
export function isUsableWebsiteSeoDocument(
  document: WebsiteSeoDocument | null | undefined
): document is WebsiteSeoDocument {
  return Boolean(
    document && document.kind !== 'unknown' && document.status >= 200 && document.status < 300
  );
}

/** Prefer the original preview baseline; otherwise use the latest successful pre-edit revision. */
export function websiteSeoBaseline(
  observations: { revision: number; document: WebsiteSeoDocument }[],
  path: string,
  revision: number
): WebsiteSeoDocument | null {
  const prior = observations.filter(
    row =>
      row.document.path === path &&
      isUsableWebsiteSeoDocument(row.document) &&
      (row.revision === 0 || row.revision < revision)
  );
  return (
    (prior.find(row => row.revision === 0) || prior.sort((a, b) => b.revision - a.revision)[0])
      ?.document || null
  );
}
